const STREET_REQUIRED = 'Street is required.';
const STREET_INVALID = 'Street is invalid.';
const APTSUITE_INVALID = 'Apt. / Suite is invalid.';
const CITY_REQUIRED = 'City is required.';
const CITY_INVALID = 'City is invalid.';
const STATE_REQUIRED = 'State is required.';
const STATE_INVALID = 'Please select a state.';
const ZIP_REQUIRED = 'Zipcode is required.';
const ZIP_INVALID = 'Zipcode is invalid.';

export const DEFAULT_STATE = 'State';

const existSpecialChars = (fieldName, str) => {
  const includesNum = (fieldName === 'street' || fieldName === 'aptsuite') ? '' : '\\d+',
    regexStr = '[\\(){}:;|!@#$%^&*_=+~`,"' + includesNum + ']',
    regex = new RegExp(regexStr, 'g');
    return regex.test(str);
};

const isPOBox = (streetAddr) => {
  const regex = /[\\!@#$%^&*-.,"\/]/gi,
    stAddr = streetAddr.trim().toLowerCase().replace(regex, '');
    return stAddr.toLowerCase().match(/(pob)|(pob [1-9]+)|(po box)|(p o box)|(pobox)|(pobox [1-9]+)|(po [1-9]+)|(p o [1-9]+)/) &&
      !stAddr.match(/^[1-9]/);
};

export const validateStreet = (value) => {
  let errMsg;
  if (value) {
    if (isPOBox(value)) {
      errMsg = 'PO Box is not allowed.';
    } else if (existSpecialChars('street', value)) {
      errMsg = STREET_INVALID;
    }
  } else {
    errMsg = STREET_REQUIRED;
  }
  return errMsg;
};

export const validateAptSuite = (value) => {
  let errMsg;
  if (value && existSpecialChars('aptsuite', value)) {
    errMsg = APTSUITE_INVALID;
  }
  return errMsg;
};

export const validateCity = (value) => {
  let errMsg;
  if (value) {
    if (existSpecialChars('city', value)) {
      errMsg = CITY_INVALID;
    }
  } else {
    errMsg = CITY_REQUIRED;
  }
  return errMsg;
};

export const validateState = (value, defaultValue = DEFAULT_STATE) => {
  let errMsg;
  if (value) {
    if (value === defaultValue) {
      errMsg = STATE_INVALID;
    }
  } else {
    errMsg = STATE_REQUIRED;
  }
  return errMsg;
};

export const validateZip = (value, maxLength = 5) => {
  let errMsg;
  if (value) {
    if (value.length < maxLength || (value.length === maxLength && value.substring(0, 3) === '000')) {
      errMsg = ZIP_INVALID;
    }
  } else {
    errMsg = ZIP_REQUIRED;
  }
  return errMsg;
};

